import { PRIORITIES } from './../mutations-types'
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    priorities: {
      items: [],
      raw: {}
    }
  },
  getters: {
    priorities: state => {
      return state.priorities
    }
  },
  mutations: {
    [PRIORITIES](state, priorities) {
      state.priorities = priorities;
    }
  },
  actions: {
    async setPriorities(store) {
      const priorities = {
        items: [],
        raw: {}
      };
      const response = await store.dispatch('request', { url: "systems/priorities?fields=id,label&limit=999" }, { root: true });
      Vue._.each(response.data.data, priority => {
        priorities.items.push({
          text: priority.label.toUpperCase(),
          value: priority.id
        });
        priorities.raw[priority.id] = priority.label
      })
      store.commit(PRIORITIES, priorities);
    }
  }
}